import AdminEmailPermissionForm from "./AdminEmailPermission";
export default AdminEmailPermissionForm;